import React from 'react';
import { KoobEnableableSection } from '@koob/ui';
import { PrivateModeKindEnum } from '@koob/enums';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export default function PrivateModeSwitch({
  privateMode,
  setPrivateMode,
  kind = PrivateModeKindEnum.DMC,
}) {
  const { t } = useTranslation('bookings');
  const location = useLocation();

  const isHotelKeeper = kind === PrivateModeKindEnum.HOTEL_KEEPER;

  return isHotelKeeper || location.pathname.includes('partner-bookings') ? (
    <div className="mb-5">
      <KoobEnableableSection
        title={t('private.title')}
        description={t(
          isHotelKeeper
            ? 'private.hotelKeeperDescription'
            : 'private.description',
        )}
        checked={privateMode}
        onCheckedChange={setPrivateMode}
        open={false}
      />
    </div>
  ) : null;
}
